import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var masterLinkListRes;
export const masterLinkListTodo = createAsyncThunk('masterLinkList', async (data) => {

    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'linkother',
            params: {
                "status": ''
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') },

        })
        return masterLinkListRes = res

    } catch (error) {
        return masterLinkListRes = error.response
    }
});

const masterLinkListSlice = createSlice({
    name: 'masterLinkList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(masterLinkListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status == 401) {
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            }
            else {
                state.data = []
            }
        });
        builder.addCase(masterLinkListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default masterLinkListSlice.reducer;

